import './AlertIcons.less';

const ErrorIcon = () => (
  <div className='f-modal-alert'>
    <div className='f-modal-icon f-modal-error animate'>
      <span className='f-modal-x-mark'>
        <span className='f-modal-line f-modal-left animateXLeft'></span>
        <span className='f-modal-line f-modal-right animateXRight'></span>
      </span>
      <div className='f-modal-placeholder'></div>
      <div className='f-modal-fix'></div>
    </div>
  </div>
);

const WarningIcon = () => (
  <div className='f-modal-alert'>
    <div className='f-modal-icon f-modal-warning scaleWarning'>
      <span className='f-modal-body pulseWarningIns'></span>
      <span className='f-modal-dot pulseWarningIns'></span>
    </div>
  </div>
);

const SuccessIcon = () => (
  <div className='f-modal-alert'>
    <div className='f-modal-icon f-modal-success animate'>
      <span className='f-modal-line f-modal-tip animateSuccessTip'></span>
      <span className='f-modal-line f-modal-long animateSuccessLong'></span>
      <div className='f-modal-placeholder'></div>
      <div className='f-modal-fix'></div>
    </div>
  </div>
);

export { SuccessIcon, WarningIcon, ErrorIcon };
